import { initializeControlFrameBrowser } from "@kontextwerk/control-web-frame/shared/logic/browser-initialization"
import App from "./App.svelte"

import { hydrate } from "svelte"
import { initSpaRouter } from "@kontextwerk/web-sdk/core/routing/navigation"

initializeControlFrameBrowser()

initSpaRouter({ stickyParams: ["userPreview"] })

const appContainer = document?.getElementById("appContainer")
const app = hydrate(App, { target: appContainer })

export default app
